const MIN_EPOCH_SECONDS = 1_000_000_000
const MIN_EPOCH_MILLISECONDS = 1_000_000_000_000
const MAX_REASONABLE_DURATION_SECONDS = 60 * 60 * 24 * 7
const MAX_REASONABLE_DURATION_MILLISECONDS = MAX_REASONABLE_DURATION_SECONDS * 1000
const ARRIVAL_PAST_TOLERANCE_MS = 5000

const toPositiveFiniteNumber = value => {
    const numericValue = Number(value)
    return Number.isFinite(numericValue) && numericValue > 0 ? numericValue : undefined
}

export const normalizeMovementArrivalCandidate = (value, now = Date.now()) => {
    const numericValue = toPositiveFiniteNumber(value)
    if (!Number.isFinite(numericValue))
        return undefined

    if (numericValue >= MIN_EPOCH_MILLISECONDS)
        return Math.trunc(numericValue)

    if (numericValue >= MIN_EPOCH_SECONDS)
        return Math.trunc(numericValue * 1000)

    if (numericValue <= MAX_REASONABLE_DURATION_SECONDS)
        return Math.trunc(now + numericValue * 1000)

    if (numericValue <= MAX_REASONABLE_DURATION_MILLISECONDS)
        return Math.trunc(now + numericValue)

    return undefined
}

export const resolveMovementArrivalTime = (movement, now = Date.now()) => {
    const serverReportedAt = toPositiveFiniteNumber(movement?.serverReportedAt)
    const serverRemainingSeconds = toPositiveFiniteNumber(movement?.serverRemainingSeconds)
    const serverArrivalTime =
        serverReportedAt !== undefined && serverRemainingSeconds !== undefined ?
            Math.trunc(serverReportedAt + serverRemainingSeconds * 1000) :
            undefined
    const candidates = [
        serverArrivalTime,
        normalizeMovementArrivalCandidate(movement?.arrivalTime, now),
        normalizeMovementArrivalCandidate(movement?.endTime, now),
        normalizeMovementArrivalCandidate(movement?.deltaTime, now)
    ].filter(candidate => Number.isFinite(candidate))

    if (candidates.length === 0)
        return undefined

    const activeCandidates = candidates.filter(candidate => candidate >= now - ARRIVAL_PAST_TOLERANCE_MS)
    if (activeCandidates.length > 0)
        return Math.min(...activeCandidates)

    return Math.max(...candidates)
}

export const resolveAttackEntryArrivalTime = (attack, now = Date.now()) =>
    resolveMovementArrivalTime({
        arrivalTime: attack?.arrivalTime,
        endTime: attack?.movement?.endTime,
        deltaTime: attack?.movement?.deltaTime,
        serverRemainingSeconds: attack?.serverRemainingSeconds ?? attack?.movement?.serverRemainingSeconds,
        serverReportedAt: attack?.serverReportedAt ?? attack?.movement?.serverReportedAt
    }, now)
